import React from 'react';


const {
    Provider: ScreenDesignerProvider,
    Consumer: ScreenDesignerConsumer
} = React.createContext();

export {
    ScreenDesignerProvider,
    ScreenDesignerConsumer
};